import { format } from 'date-fns';
import ICashFlow from '~/interfaces/ICashFlow';
import ICompany from '~/interfaces/ICompany';
import getCurrencyFormatted from './getCurrencyFormatted';
import IOrder from '~/interfaces/IOrder';

interface getPrintCashFlowHTMLProps {
  company: ICompany;
  launchs: ICashFlow[];
  orders: IOrder[];
}

export function getPrintCashFlowHTML({
  company,
  launchs,
  orders,
}: getPrintCashFlowHTMLProps): string {
  console.log(launchs);

  const openedAt = launchs.find(item => item.type === '100');

  if (!openedAt) {
    throw new Error('Atenção! O caixa não foi aberto.');
  }

  const openedAtDate = format(
    new Date((openedAt.date as any).seconds * 1000),
    'dd/MM/yyyy HH:mm',
  );

  const closedAt = launchs.find(item => item.type === '99');

  // if (!closedAt) {
  //   throw new Error('Atenção! O caixa não foi fechado.');
  // }

  const closedAtDate = closedAt
    ? format(
        new Date((closedAt.date as any).seconds * 1000),
        'dd/MM/yyyy HH:mm',
      )
    : format(new Date(), 'dd/MM/yyyy HH:mm');

  let suppliesBalance = 0;
  let sangriaBalance = 0;

  launchs.forEach(item => {
    if (item.type === '1') suppliesBalance += item.value;
    if (item.type === '0') sangriaBalance += item.value;
  });

  const resumeSales = {
    moneyBalance: 0,
    pixBalance: 0,
    creditBalance: 0,
    debitBalance: 0,
    ifoodBalance: 0,
    total: 0,
  };

  const resumeSalesDelivery = {
    moneyBalance: 0,
    pixBalance: 0,
    creditBalance: 0,
    debitBalance: 0,
    ifoodBalance: 0,
    taxBalance: 0,
    valueProducts: 0,
    total: 0,
  };

  const resumeSalesLocal = {
    moneyBalance: 0,
    pixBalance: 0,
    creditBalance: 0,
    debitBalance: 0,
    total: 0,
  };

  const resumeSalesTable = {
    moneyBalance: 0,
    pixBalance: 0,
    creditBalance: 0,
    debitBalance: 0,
    total: 0,
  };

  orders.forEach(item => {
    // retirada local
    if (
      item.order_type === '0' &&
      !item.table &&
      !item.name.toLowerCase().includes('mesa')
    ) {
      if (item.paymentMethod === '0')
        resumeSalesLocal.moneyBalance += item.total;
      if (item.paymentMethod === '1')
        resumeSalesLocal.debitBalance += item.total;
      if (item.paymentMethod === '2')
        resumeSalesLocal.creditBalance += item.total;
      if (item.paymentMethod === '3') resumeSalesLocal.pixBalance += item.total;

      item.orderPayments.forEach(payment => {
        if (payment.payment_method_id === '0')
          resumeSalesLocal.moneyBalance += item.total;
        if (payment.payment_method_id === '1')
          resumeSalesLocal.debitBalance += item.total;
        if (payment.payment_method_id === '2')
          resumeSalesLocal.creditBalance += item.total;
        if (payment.payment_method_id === '3')
          resumeSalesLocal.pixBalance += item.total;
      });
    }

    // mesas
    if (
      item.order_type === '2' ||
      item.table ||
      item.name.toLowerCase().includes('mesa')
    ) {
      if (item.paymentMethod === '0')
        resumeSalesTable.moneyBalance += item.total;
      if (item.paymentMethod === '1')
        resumeSalesTable.debitBalance += item.total;
      if (item.paymentMethod === '2')
        resumeSalesTable.creditBalance += item.total;
      if (item.paymentMethod === '3') resumeSalesTable.pixBalance += item.total;

      if (item.orderPayments) {
        item.orderPayments.forEach(payment => {
          if (payment.payment_method_id === '0')
            resumeSalesTable.moneyBalance += item.total;
          if (payment.payment_method_id === '1')
            resumeSalesTable.debitBalance += item.total;
          if (payment.payment_method_id === '2')
            resumeSalesTable.creditBalance += item.total;
          if (payment.payment_method_id === '3')
            resumeSalesTable.pixBalance += item.total;
        });
      }
    }

    // delivery
    if (item.order_type === '1') {
      resumeSalesDelivery.taxBalance += item.shippingCost;

      if (item.paymentMethod === '0')
        resumeSalesDelivery.moneyBalance += item.total;
      if (item.paymentMethod === '1')
        resumeSalesDelivery.debitBalance += item.total;
      if (item.paymentMethod === '2')
        resumeSalesDelivery.creditBalance += item.total;
      if (item.paymentMethod === '3')
        resumeSalesDelivery.pixBalance += item.total;
      if (item.paymentMethod === '5')
        resumeSalesDelivery.ifoodBalance += item.total;

      if (item.orderPayments) {
        item.orderPayments.forEach(payment => {
          if (payment.payment_method_id === '0')
            resumeSalesDelivery.moneyBalance += item.total;
          if (payment.payment_method_id === '1')
            resumeSalesDelivery.debitBalance += item.total;
          if (payment.payment_method_id === '2')
            resumeSalesDelivery.creditBalance += item.total;
          if (payment.payment_method_id === '3')
            resumeSalesDelivery.pixBalance += item.total;
          if (payment.payment_method_id === '5')
            resumeSalesDelivery.ifoodBalance += item.total;
        });
      }
    }

    if (item.paymentMethod === '0') resumeSales.moneyBalance += item.total;
    if (item.paymentMethod === '1') resumeSales.debitBalance += item.total;
    if (item.paymentMethod === '2') resumeSales.creditBalance += item.total;
    if (item.paymentMethod === '3') resumeSales.pixBalance += item.total;
    if (item.paymentMethod === '5') resumeSales.ifoodBalance += item.total;

    if (item.orderPayments) {
      item.orderPayments.forEach(payment => {
        if (payment.payment_method_id === '0')
          resumeSales.moneyBalance += item.total;
        if (payment.payment_method_id === '1')
          resumeSales.debitBalance += item.total;
        if (payment.payment_method_id === '2')
          resumeSales.creditBalance += item.total;
        if (payment.payment_method_id === '3')
          resumeSales.pixBalance += item.total;
        if (payment.payment_method_id === '5')
          resumeSales.ifoodBalance += item.total;
      });
    }
  });

  const valueInCash =
    openedAt.value +
    suppliesBalance -
    sangriaBalance +
    resumeSales.moneyBalance;

  resumeSales.total =
    resumeSales.moneyBalance +
    resumeSales.pixBalance +
    resumeSales.creditBalance +
    resumeSales.debitBalance +
    resumeSales.ifoodBalance;

  resumeSalesDelivery.total =
    resumeSalesDelivery.moneyBalance +
    resumeSalesDelivery.pixBalance +
    resumeSalesDelivery.creditBalance +
    resumeSalesDelivery.debitBalance +
    resumeSalesDelivery.ifoodBalance;

  resumeSalesDelivery.valueProducts =
    resumeSalesDelivery.total - resumeSalesDelivery.taxBalance;

  resumeSalesLocal.total =
    resumeSalesLocal.moneyBalance +
    resumeSalesLocal.pixBalance +
    resumeSalesLocal.creditBalance +
    resumeSalesLocal.debitBalance;

  resumeSalesTable.total =
    resumeSalesTable.moneyBalance +
    resumeSalesTable.pixBalance +
    resumeSalesTable.creditBalance +
    resumeSalesTable.debitBalance;

  return `
  <!DOCTYPE html>
  <html lang="pt-BR">

  <head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Relatório de Caixa</title>
    <style>
      body {
        display: flex;
        justify-content: center;
      }

      .text-center {
        text-align: center;
      }

      .ttu {
        text-transform: uppercase;
      }

      .printer-ticket {
        display: table !important;
        width: 100%;
        max-width: 300px;
        font-weight: light;
        line-height: 1.3em;
      }

      .printer-ticket,
      .printer-ticket * {
        font-family: Tahoma, Geneva, sans-serif;
        font-size: 16px;
      }

      .printer-ticket th:nth-child(2),
      .printer-ticket td:nth-child(2) {
        width: 50px;
      }

      .printer-ticket th:nth-child(3),
      .printer-ticket td:nth-child(3) {
        width: 90px;
        text-align: right;
      }

      .printer-ticket th {
        font-weight: inherit;
        padding: 10px 0;
        text-align: center;
        border-bottom: 1px dashed #bcbcbc;
      }

      .printer-ticket tbody tr:last-child td {
        padding-bottom: 10px;
      }

      .printer-ticket tfoot .sup td {
        padding: 10px 0;
        border-top: 1px dashed #bcbcbc;
      }

      .printer-ticket tfoot .sup.p--0 td {
        padding-bottom: 0;
      }

      .printer-ticket .title {
        font-size: 1.5em;
        padding: 15px 0;
      }

      .printer-ticket .top td {
        padding-top: 10px;
      }

      .printer-ticket .last td {
        padding-bottom: 10px;
      }

      .printer-ticket tr td {
        min-width: 150px;
      }
    </style>
  </head>

  <body>
    <table class="printer-ticket">
      <tbody>
        <tr>
          <th class="title" colspan="3">
            <b>${company.fantasy}</b>
          </th>
        </tr>
        <tr>
          <th colspan="3">
            <span>Relatório de Caixa</span>
          </th>
        </tr>
        <tr>
          <th colspan="3">
            <div style="display: flex; width: 100%; justify-content: space-between;">
              <p style="text-align: left; margin: 0;">
                ABERTO EM <br>
                ${openedAtDate}
              </p>
              <p style="text-align: right; margin: 0;">
                FECHADO EM <br>
                ${closedAtDate}
              </p>
            </div>
          </th>
        </tr>

        <tr>
          <th class="ttu" colspan="3" style="text-align: left;">
            <b>RESUMO DO CAIXA</b>
          </th>
        </tr>

        <tr>
          <td colspan="2" style="padding-top: 12px;">SALDO INICIAL</td>
          <td align="right" style="padding-top: 12px;">${
            openedAt.value_formatted
          }</td>
        </tr>
        <tr>
          <td colspan="2">SUPRIMENTOS</td>
          <td align="right">${getCurrencyFormatted(suppliesBalance)}</td>
        </tr>
        <tr>
          <td colspan="2">SANGRIAS</td>
          <td align="right">${getCurrencyFormatted(sangriaBalance)}</td>
        </tr>
        <tr>
          <td colspan="2">VENDAS EM DINHEIRO</td>
          <td align="right">${getCurrencyFormatted(
            resumeSales.moneyBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">VALOR EM CAIXA</td>
          <td align="right">${getCurrencyFormatted(valueInCash)}</td>
        </tr>

        <tr><th colspan="3" style="padding: 4px;"></th></tr>
        <tr>
          <td class="ttu" colspan="3" style="padding-top: 8px">
            <b>RESUMO DAS VENDAS</b>
          </td>
        </tr>
        <tr><th colspan="3" style="padding: 4px;"></th></tr>
        <tr>
          <td colspan="2" style="padding-top: 12px;">DINHEIRO</td>
          <td align="right" style="padding-top: 12px;">${getCurrencyFormatted(
            resumeSales.moneyBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">PIX</td>
          <td align="right">${getCurrencyFormatted(resumeSales.pixBalance)}</td>
        </tr>
        <tr>
          <td colspan="2">CRÉDITO</td>
          <td align="right">${getCurrencyFormatted(
            resumeSales.creditBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">DÉBITO</td>
          <td align="right">${getCurrencyFormatted(
            resumeSales.debitBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">IFOOD</td>
          <td align="right">${getCurrencyFormatted(
            resumeSales.ifoodBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">TOTAL</td>
          <td align="right">${getCurrencyFormatted(resumeSales.total)}</td>
        </tr>


        <tr><th colspan="3" style="padding: 4px;"></th></tr>
        <tr>
          <td class="ttu" colspan="3" style="padding-top: 8px">
            <b>VENDAS DELIVERY</b>
          </td>
        </tr>
        <tr><th colspan="3" style="padding: 4px;"></th></tr>
        <tr>
          <td colspan="2" style="padding-top: 12px;">DINHEIRO</td>
          <td align="right" style="padding-top: 12px;">${getCurrencyFormatted(
            resumeSalesDelivery.moneyBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">PIX</td>
          <td align="right">${getCurrencyFormatted(
            resumeSalesDelivery.pixBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">CRÉDITO</td>
          <td align="right">${getCurrencyFormatted(
            resumeSalesDelivery.creditBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">DÉBITO</td>
          <td align="right">${getCurrencyFormatted(
            resumeSalesDelivery.debitBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">IFOOD</td>
          <td align="right">${getCurrencyFormatted(
            resumeSalesDelivery.ifoodBalance,
          )}</td>
        </tr>
        <tr><th colspan="3" style="padding: 4px;"></th></tr>
        <tr>
          <td colspan="2">VALOR DOS PRODUTOS</td>
          <td align="right">${getCurrencyFormatted(
            resumeSalesDelivery.valueProducts,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">TAXA DE ENTREGA</td>
          <td align="right">${getCurrencyFormatted(
            resumeSalesDelivery.taxBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">TOTAL</td>
          <td align="right">${getCurrencyFormatted(
            resumeSalesDelivery.total,
          )}</td>
        </tr>

        <tr><th colspan="3" style="padding: 4px;"></th></tr>
        <tr>
          <td class="ttu" colspan="3" style="padding-top: 8px">
            <b>VENDAS RETIRADA</b>
          </td>
        </tr>
        <tr><th colspan="3" style="padding: 4px;"></th></tr>
        <tr>
          <td colspan="2" style="padding-top: 12px;">DINHEIRO</td>
          <td align="right" style="padding-top: 12px;">${getCurrencyFormatted(
            resumeSalesLocal.moneyBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">PIX</td>
          <td align="right">${getCurrencyFormatted(
            resumeSalesLocal.pixBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">CRÉDITO</td>
          <td align="right">${getCurrencyFormatted(
            resumeSalesLocal.creditBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">DÉBITO</td>
          <td align="right">${getCurrencyFormatted(
            resumeSalesLocal.debitBalance,
          )}</td>
        </tr>
        <tr><th colspan="3" style="padding: 4px;"></th></tr>
        <tr>
          <td colspan="2">TOTAL</td>
          <td align="right">${getCurrencyFormatted(resumeSalesLocal.total)}</td>
        </tr>

        <tr><th colspan="3" style="padding: 4px;"></th></tr>

        <tr>
          <td class="ttu" colspan="3" style="padding-top: 8px">
            <b>VENDAS MESAS</b>
          </td>
        </tr>
        <tr><th colspan="3" style="padding: 4px;"></th></tr>
        <tr>
          <td colspan="2" style="padding-top: 12px;">DINHEIRO</td>
          <td align="right" style="padding-top: 12px;">${getCurrencyFormatted(
            resumeSalesTable.moneyBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">PIX</td>
          <td align="right">${getCurrencyFormatted(
            resumeSalesTable.pixBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">CRÉDITO</td>
          <td align="right">${getCurrencyFormatted(
            resumeSalesTable.creditBalance,
          )}</td>
        </tr>
        <tr>
          <td colspan="2">DÉBITO</td>
          <td align="right">${getCurrencyFormatted(
            resumeSalesTable.debitBalance,
          )}</td>
        </tr>
        <tr><th colspan="3" style="padding: 4px;"></th></tr>
        <tr>
          <td colspan="2">TOTAL</td>
          <td align="right">${getCurrencyFormatted(resumeSalesTable.total)}</td>
        </tr>

        <tr><th colspan="3" style="padding: 4px;"></th></tr>

        <tr class="sup p--0">
          <td colspan="3" align="center">
            Tecnologia
          </td>
        </tr>
        <tr>
          <td colspan="3" align="center">
            www.tem-pedido.web.app
          </td>
        </tr>
        <tr style="height: 85px" />
        <tr>
          <td colspan="3" align="center">
            -
          </td>
        </tr>
      </tbody>
    </table>
  </body>
  </html>
`;
}
